/* eslint-disable react-hooks/exhaustive-deps */
import React from "react";
import useState from "react-usestateref";
import axios from "axios";
import { toast } from "react-toastify";

import { ServiceCodeTable } from "../../components/Tables";

export default ({ load, setShowSignin, handleEditData }) => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(1);
  React.useEffect(() => {
    getData();
  }, [load, page]);

  const config = {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${localStorage.accessToken}`,
    },
  };
  const getData = () => {
    setLoading(true);
    axios
      .get(
        `${process.env.REACT_APP_BACKEND_API}/v1/short-code?page=${page}`,
        config
      )
      .then((res) => {
        setData(res.data.results);
        setLoading(false);
        toast.success("Service code");
      })
      .catch((err) => {
        setData([]);
        setLoading(false);
        toast.error("Unexpected error");
      });
  };

  return (
    <>
      <ServiceCodeTable
        handleEditData={handleEditData}
        data={data}
        loading={loading}
        setPage={setPage}
        setShowSignin={setShowSignin}
      />
    </>
  );
};
